import React, { type SetStateAction } from 'react'
import { Box, Link, MenuItem, Popover, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import IconArrowDown from './IconArrowDown'
import IconArrowDownWP from './IconArrowDownWP'
import LinkSvg from './LinkSvg'
import NavigationLink from './NavigationLink'
import navConfigMyWebsite from './configMyWebste'
import { useSelector } from 'react-redux'
import { LINKS } from '../../../../utils/constants/links'
import type { IUserProfile } from '../../../../redux/api/types'

const PopOverManageWebsite = ({ setMobileOpen }: { setMobileOpen?: React.Dispatch<SetStateAction<boolean>> }) => {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = React.useState<any>(null)
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const mode = useSelector((state: any) => state.modeState)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
        <>
            <MenuItem onClick={handleClick} className={`header-menu-item ${mode.isWp === true ? 'active' : ''}`} sx={{
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.primary.contrastText,
              cursor: 'pointer',
              ml: isMobile ? '4px' : '',
              borderRadius: isMobile ? '10px' : '35px',
              height: isMobile ? '51px' : '33px',
              '&:hover': {
                color: theme.palette.grey[50]
              }
            }}>
                My Website
                {mode.isWp === true ? <IconArrowDownWP/> : <IconArrowDown/>}
            </MenuItem>
            <Popover
                className={'header-popover'}
                id={id}
                open={open}
                anchorEl={anchorEl}
                anchorPosition={{ top: 200, left: 400 }}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
                }}
                PaperProps={{
                  style: {
                    width: '156px',
                    height: '87px',
                    zIndex: '1300',
                    overflow: 'hidden'
                  }
                }}
            >
                <Link
                    href={LINKS.VIEW_MY_WEBSITE(user)}
                    target="_blank"
                    rel="noopener"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '44px',
                      pl: '18px',
                      color: theme.palette.primary.contrastText,
                      cursor: 'pointer',
                      mr: 0,
                      '&:hover': {
                        color: theme.palette.grey[50],
                        textDecoration: 'none'
                      }
                    }}>
                    View My Website
                    <LinkSvg/>
                </Link>
                <Box sx={{ display: 'flex', alignItems: 'center', height: '43px' }}>
                    {navConfigMyWebsite().map(item =>
                        <NavigationLink
                            key={item.title}
                            path={item.path}
                            title={item.title}
                            setMobileOpen={setMobileOpen}
                            isNav={true}
                            disabled={user?.isPaymentPastDue ?? true}
                      />
                    )}
                </Box>
            </Popover>
        </>
  )
}

export default PopOverManageWebsite
